import review from "./review.router"
export default [
    {
        path: '/sys',
        name: 'sys',
        component: () => import('@/views/sys/'),
        meta: {title: "个人中心", requireLogin: true},
        children: [
            {
                path: '/sys/userIndex',
                name: 'sys_userIndex',
                component: () => import('@/views/sys/userIndex'),
                meta: {title: "首页", requireLogin: true}
            },
            {
                path: '/sys/userInfo',
                name: 'sys_userInfo',
                component: () => import('@/views/sys/userInfo'),
                meta: {title: "菜单管理", requireLogin: true}
            },
            // {
            //     path: '/sys/userIndex',
            //     name: 'sys_userIndex',
            //     component: () => import('@/views/sys/userInfo'),
            //     meta: {title: "菜单管理", requireLogin: true}
            // },
            {
                path: '/sys/messageList',
                name: 'sys_messageList',
                component: () => import('@/views/sys/messageList'),
                meta: {title: "消息列表", requireLogin: true}
            },
            {
                path: '/sys/EnterpriseSealService',
                name: 'sys_EnterpriseSealService',
                component: () => import('@/views/sys/EnterpriseSealService'),
                meta: {title: "企业刻章服务", requireLogin: true}
            },
            {
                path: '/sys/EnterpriseSealService/Add',
                name: 'sys_EnterpriseSealServiceAdd',
                component: () => import('@/views/sys/EnterpriseSealService/components/AddOrEditModal'),
                meta: {title: "新办企业刻章服务", requireLogin: true}
            },
            {
                path: '/sys/basicsBaseMsg',
                name: 'sys_basicsBaseMsg',
                component: () => import('@/views/sys/basicsBaseMsg'),
                meta: {title: "基地通知列表", requireLogin: true}
            },

            // 积分制
            {
                path: '/sys/manage',
                name: 'sys_manage',
                component: () => import('@/views/sys/integralManage'),
                meta: {title: "积分制", requireLogin: true}
            },
            {
                path: '/sys/integral',
                name: 'sys_integral',
                component: () => import('@/views/sys/integral'),
                meta: {title: "积分制填报", requireLogin: true}
            },
            {
                path: '/sys/TechnologieprojekteApply',
                name: 'sys_TechnologieprojekteApply',
                component: () => import('@/views/sys/TechnologieprojekteApply'),
                meta: {title: "科技项目申报", requireLogin: true}
            },
            {
                path: '/sys/financedemand',
                name: 'sys_financedemand',
                component: () => import('@/views/sys/financedemand'),
                meta: {title: "金融需求", requireLogin: true}
            },
            {
                path: '/sys/TechnologieApplyDetail',
                name: 'sys_TechnologieApplyDetail',
                component: () => import('@/views/sys/TechnologieprojekteApply/components/Detail'),
                meta: {title: "科技详情", requireLogin: true}
            },
            {
                path: '/sys/TechnologieApplyModel',
                name: 'sys_TechnologieApplyModel',
                component: () => import('@/views/sys/TechnologieprojekteApply/components/TechnologieApplyModel'),
                meta: {title: "科技项目申报入口", requireLogin: true}
            },
            {
                path: '/sys/policyPublicData',
                name: 'sys_policyPublicData',
                component: () => import('@/views/sys/policy/policyPublicData'),
                meta: {title: "政策兑现公共资料维护", requireLogin: true}
            },
            {
                path: '/sys/intellectualsubsidy',
                name: 'sys_intellectualsubsidy',
                component: () => import('@/views/sys/policy/Intellectualsubsidy'),
                meta: {title: "专利授权补贴", requireLogin: true}
            },
            {
                path: '/sys/highTechEnterprises',
                name: 'sys_highTechEnterprises',
                component: () => import('@/views/sys/policy/highTechEnterprises'),
                meta: {title: "高新技术企业补贴", requireLogin: true}
            },
            {
                path: '/sys/intermediarysubsidy',
                name: 'sys_intermediarysubsidy',
                component: () => import('@/views/sys/policy/Intermediarysubsidy'),
                meta: {title: "中介机构补贴", requireLogin: true}
            },
            {
                path: '/sys/innovationsubsidy',
                name: 'sys_innovationsubsidy',
                component: () => import('@/views/sys/policy/innovationsubsidy'),
                meta: {title: "双创载体培育高企补贴", requireLogin: true}
            },
            {
                path: '/sys/fundsTracking',
                name: 'sys_fundsTracking',
                component: () => import('@/views/sys/policy/fundsTracking'),
                meta: {title: "双创载体培育高企补贴", requireLogin: true}
            },
            {
                path: '/sys/certificationsubsidy',
                name: 'sys_certificationsubsidy',
                component: () => import('@/views/sys/policy/certificationsubsidy'),
                meta: {title: "双软认证补贴", requireLogin: true}
            },
            {
                path: '/sys/technologyawards',
                name: 'sys_technologyawards',
                component: () => import('@/views/sys/policy/technologyawards'),
                meta: {title: "科技奖项补贴", requireLogin: true}
            },
            {
                path: '/sys/innovationvouchers',
                name: 'sys_innovationvouchers',
                component: () => import('@/views/sys/policy/innovationvouchers'),
                meta: {title: "区级创新券兑现", requireLogin: true}
            },
            {
                path: '/sys/platformssubsidy',
                name: 'sys_platformssubsidy',
                component: () => import('@/views/sys/policy/platformssubsidy'),
                meta: {title: "科技研发类平台补贴", requireLogin: true}
            },
            {
                path: '/sys/developmentsubsidy',
                name: 'sys_developmentsubsidy',
                component: () => import('@/views/sys/policy/developmentsubsidy'),
                meta: {title: "研发机构补贴", requireLogin: true}
            },
            {
                path: '/sys/technologyProjects',
                name: 'sys_technologyProjects',
                component: () => import('@/views/sys/policy/technologyProjects'),
                meta: {title: "科技项目补贴", requireLogin: true}
            },
            {
                path: '/sys/technologyEnterprise',
                name: 'sys_technologyEnterprise',
                component: () => import('@/views/sys/policy/technologyEnterprise'),
                meta: {title: "双创载体认定补贴", requireLogin: true}
            },
            {
                path: '/sys/technologyBasedEnterprises',
                name: 'sys_technologyBasedEnterprises',
                component: () => import('@/views/sys/policy/technologyBasedEnterprises'),
                meta: {title: "科技型企业补贴", requireLogin: true}
            },
            {
                path: '/sys/technologySubsidyRevenue',
                name: 'sys_technologySubsidyRevenue',
                component: () => import('@/views/sys/policy/technologySubsidyRevenue'),
                meta: {title: "高企营收上台阶奖励补贴", requireLogin: true}
            },
            {
                path: '/sys/entrepreneurshipSubsidy',
                name: 'sys_entrepreneurshipSubsidy',
                component: () => import('@/views/sys/policy/entrepreneurshipSubsidy'),
                meta: {title: "创新创业大赛补贴", requireLogin: true}
            },
            {
                path: '/sys/intellectualproperty',
                name: 'sys_intellectualproperty',
                component: () => import('@/views/sys/policy/intellectualproperty'),
                meta: {title: "知识产权运营补贴", requireLogin: true}
            },
            {
                path: '/sys/districtlevelSubsidies',
                name: 'sys_districtlevelSubsidies',
                component: () => import('@/views/sys/policy/districtlevelSubsidies'),
                meta: {title: "区级展翼瞪羚独角兽补贴", requireLogin: true}
            },
            {
                path: '/sys/technicalcontract',
                name: 'sys_technicalcontract',
                component: () => import('@/views/sys/policy/technicalcontract'),
                meta: {title: "技术合同补贴", requireLogin: true}
            },
            {
                path: '/sys/enteredenterprises',
                name: 'sys_enteredenterprises',
                component: () => import('@/views/sys/policy/enteredenterprises'),
                meta: {title: "新入库企业补贴", requireLogin: true}
            },
            {
                path: '/sys/enterprisesinstock',
                name: 'sys_enterprisesinstock',
                component: () => import('@/views/sys/policy/enterprisesinstock'),
                meta: {title: "已在库企业补贴", requireLogin: true}
            },
            {
                path: '/sys/researchcosts',
                name: 'sys_researchcosts',
                component: () => import('@/views/sys/policy/researchcosts'),
                meta: {title: "研发费用补贴", requireLogin: true}
            },
            {
                path: '/sys/flexibletalent',
                name: 'sys_flexibletalent',
                component: () => import('@/views/sys/policy/flexibletalent'),
                meta: {title: "企业柔性引才", requireLogin: true}
            },
            {
                path: '/sys/enterpriseInnovation',
                name: 'sys_enterpriseInnovation',
                component: () => import('@/views/sys/policy/enterpriseInnovation'),
                meta: {title: "企业创新创业", requireLogin: true}
            },
            {
                path: '/sys/enterpriseRelocation',
                name: 'sys_enterpriseRelocation',
                component: () => import('@/views/sys/policy/enterpriseRelocation'),
                meta: {title: "高企迁入奖补", requireLogin: true}
            },
            {
                path: '/sys/highquality',
                name: 'sys_highquality',
                component: () => import('@/views/sys/policy/highquality'),
                meta: {title: "高企提质增效", requireLogin: true}
            },
            {
                path: '/sys/devCost',
                name: 'sys_devCost',
                component: () => import('@/views/sys/policy/devcost'),
                meta: {title: "高企研发费用奖励", requireLogin: true}
            },
            {
                path: '/sys/improvingSubsidy',
                name: 'sys_improvingSubsidy',
                component: () => import('@/views/sys/policy/improvingSubsidy'),
                meta: {title: "双创载体质量提升补贴", requireLogin: true}
            },
            {
                path: '/sys/warehousingReward',
                name: 'sys_warehousingReward',
                component: () => import('@/views/sys/policy/warehousingReward'),
                meta: {title: "企业入库奖励", requireLogin: true}
            },

            // TODO 档案管理开始
            {
                path: '/sys/companyInfo',
                name: 'sys_companyInfo',
                component: () => import('@/views/sys/company/companyInfo'),
                meta: {title: "企业信息", requireLogin: true}
            },
            {
                path: '/sys/companyDigital',
                name: 'sys_companyDigital',
                component: () => import('@/views/sys/company/digital'),
                meta: {title: "数字化服务商信息", requireLogin: true}
            },
            {
                path: '/sys/finance',
                name: 'sys_finance',
                component: () => import('@/views/sys/company/finance'),
                meta: {title: "财务信息", requireLogin: true}
            },
            {
                path: '/sys/honor',
                name: 'sys_honor',
                component: () => import('@/views/sys/company/honor'),
                meta: {title: "企业资质荣誉", requireLogin: true}
            },
            {
                path: '/sys/extend',
                name: 'sys_extend',
                component: () => import('@/views/sys/company/extend'),
                meta: {title: "扩展信息", requireLogin: true}
            },
            {
                path: '/sys/talent',
                name: 'sys_talent',
                component: () => import('@/views/sys/company/talent'),
                meta: {title: "高级人才管理", requireLogin: true}
            },
            {
                path: '/sys/pyNotice',
                name: 'sys_pyNotice',
                component: () => import('@/views/sys/pyNotice'),
                meta: {title: "知识产权管理", requireLogin: true}
            },

            // TODO 档案管理结束

            {
                path: '/sys/admin',
                name: 'sys_admin',
                component: () => import('@/views/sys/admin'),
                meta: {title: "系统用户", requireLogin: true}
            },
            {
                path: '/sys/menu',
                name: 'sys_menu',
                component: () => import('@/views/sys/menu'),
                meta: {title: "菜单管理", requireLogin: true}
            },
            {
                path: '/sys/role',
                name: 'sys_role',
                component: () => import('@/views/sys/role'),
                meta: {title: "角色管理", requireLogin: true}
            },
            {
                path: '/sys/dict',
                name: 'sys_dict',
                component: () => import('@/views/sys/dict'),
                meta: {title: "系统字典", requireLogin: true}
            },
            {
                path: '/sys/sensitive_words',
                name: 'sys_sensitive_words',
                component: () => import('@/views/sys/sensitiveWords'),
                meta: {title: "敏感词配置", requireLogin: true}
            },
            // TODO 创新创业子平台
            {
                path: '/sys/innovation/release',
                name: 'Innovation_release',
                component: () => import('@/views/sys/innovation/release/index'),
                meta: { title: "需求发布", requireLogin: true }
            },
            {
                path: '/sys/innovation/industry',
                name: 'Innovation_industry',
                component: () => import('@/views/sys/innovation/industry/index'),
                meta: { title: "产业需求", requireLogin: true }
            },
            {
                path: '/sys/innovation/visit/index',
                name: 'Innovation-visit',
                component: () => import('@/views/sys/innovation/visit/index'),
                meta: {title: "安全中心", requireLogin: true}
            },
            {
                path: '/sys/innovation/policy/index',
                name: 'Innovation-policy',
                component: () => import('@/views/sys/innovation/policy/index'),
                meta: {title: "政策匹配", requireLogin: true}
            },
            {
                path: '/sys/innovation/organization/index',
                name: 'Innovation-organization',
                component: () => import('@/views/sys/innovation/organization/index'),
                meta: {title: "服务机构", requireLogin: true}
            },
            {
                path: '/sys/innovation/activity/index',
                name: 'Innovation-activity',
                component: () => import('@/views/sys/innovation/activity/index'),
                meta: {title: "活动报名", requireLogin: true}
            },
            {
                path: '/sys/innovation/collect/index',
                name: 'Innovation-collect',
                component: () => import('@/views/sys/innovation/collect/index'),
                meta: {title: "我的收藏", requireLogin: true}
            },
            {
                path: '/sys/innovation/selftest/index',
                name: 'Innovation-selftest',
                component: () => import('@/views/sys/innovation/selftest/index'),
                meta: {title: "创新自测", requireLogin: true}
            },
            {
                path: '/sys/innovation/notification/index',
                name: 'Innovation-notification',
                component: () => import('@/views/sys/innovation/notification/index'),
                meta: {title: "消息通知", requireLogin: true}
            },
            {
                path: '/sys/innovation/scientific/laboratory',
                name: 'Innovation-laboratory',
                component: () => import('@/views/sys/innovation/scientific/laboratory'),
                meta: {title: "重点实验室", requireLogin: true}
            },
            {
                path: '/sys/innovation/scientific/engineering',
                name: 'Innovation-engineering',
                component: () => import('@/views/sys/innovation/scientific/engineering'),
                meta: {title: "工程技术研究中心", requireLogin: true}
            },
            {
                path: '/sys/innovation/scientific/mechanism',
                name: 'Innovation-mechanism',
                component: () => import('@/views/sys/innovation/scientific/mechanism'),
                meta: {title: "科研机构", requireLogin: true}
            },
            {
                path: '/sys/innovation/scientific/technology',
                name: 'Innovation-technology',
                component: () => import('@/views/sys/innovation/scientific/technology'),
                meta: {title: "企业技术中心", requireLogin: true}
            },
            {
                path: '/sys/innovation/scientific/alliance',
                name: 'Innovation-alliance',
                component: () => import('@/views/sys/innovation/scientific/alliance'),
                meta: {title: "产业技术创新战略联盟", requireLogin: true}
            },
            {
                path: '/sys/innovation/base',
                name: 'Innovation-base',
                component: () => import('@/views/sys/innovation/base'),
                meta: {title: "入驻基地", requireLogin: true}
            },
            {
                path: '/sys/innovation/history',
                name: 'Innovation-history',
                component: () => import('@/views/sys/innovation/history'),
                meta: {title: "历史入驻基地", requireLogin: true}
            },
            {
                path: '/sys/innovation/abutment',
                name: 'Innovation-abutment',
                component: () => import('@/views/sys/innovation/abutment'),
                meta: {title: "对接需求管理", requireLogin: true}
            },
            // TODO 创新创业结束

            // TODO 科技金融
            {
                path: '/finance/InformationSupplement',
                name: 'finance_InformationSupplement',
                component: () => import('@/views/sys/finance/InformationSupplement'),
                meta: {title: "信息补充", requireLogin: true}
            },
            {
                path: '/finance/activity',
                name: 'finance_activity',
                component: () => import('@/views/sys/finance/activity'),
                meta: {title: "活动报名", requireLogin: true}
            },
            {
                path: '/finance/collects',
                name: 'finance_collects',
                component: () => import('@/views/sys/finance/collects'),
                meta: {title: "我的收藏", requireLogin: true}
            },
            {
                path: '/finance/demandManagement',
                name: 'finance_demandManagement',
                component: () => import('@/views/sys/finance/demandManagement'),
                meta: {title: "需求管理", requireLogin: true}
            },
            {
                path: '/finance/projectManagement',
                name: 'finance_projectManagement',
                component: () => import('@/views/sys/finance/projectManagement'),
                meta: {title: "项目管理", requireLogin: true}
            },
            {
                path: '/finance/financialNeed',
                name: 'finance_financialNeed',
                component: () => import('@/views/sys/finance/financialNeed'),
                meta: {title: "融资需求", requireLogin: true}
            },
            {
                path: '/finance/financialDynamics',
                name: 'finance_financialDynamics',
                component: () => import('@/views/sys/finance/financialDynamics'),
                meta: {title: "金融动态", requireLogin: true}
            },

            //股权融资 equityFinancing
            {
                path: '/finance/investAbutment',
                name: 'finance_investAbutment',
                component: () => import('@/views/sys/finance/equityFinancing/investAbutments'),
                meta: {title: "投资对接", requireLogin: true}
            },
            {
                path: '/finance/contactInvestors',
                name: 'finance_contactInvestors',
                component: () => import('@/views/sys/finance/equityFinancing/contactInvestors'),
                meta: {title: "联系投资人", requireLogin: true}
            },
            {
                path: '/finance/contactInvestorsManager',
                name: 'finance_contactInvestorsManager',
                component: () => import('@/views/sys/finance/equityFinancing/contactInvestorsManager'),
                meta: {title: "联系投资经理", requireLogin: true}
            },
            {
                path: '/finance/roadShowPost',
                name: 'finance_roadShowPost',
                component: () => import('@/views/sys/finance/equityFinancing/roadShowPost'),
                meta: {title: "路演活动报名", requireLogin: true}
            },
            {
                path: '/sys/finance/abutmentNeed',
                name: 'finance-abutmentNeed',
                component: () => import('@/views/sys/finance/abutmentNeed'),
                meta: {title: "对接需求管理", requireLogin: true}
            },
            //金融产品
            {
                path: '/finance/productApplication',
                name: 'finance_productApplication',
                component: () => import('@/views/sys/finance/productApplication'),
                meta: {title: "金融产品申请", requireLogin: true}
            },
            //投资人中心 InvestorCenter
            {
                path: '/finance/investorInformation',
                name: 'finance_investorInformation',
                component: () => import('@/views/sys/finance/InvestorCenter/investorInformation'),
                meta: {title: "基本信息", requireLogin: true}
            },
            {
                path: '/finance/investorGetBP',
                name: 'finance_investorGetBP',
                component: () => import('@/views/sys/finance/InvestorCenter/investorGetBP'),
                meta: {title: "收到BP", requireLogin: true}
            },
            {
                path: '/finance/investorPostBP',
                name: 'finance_investorPostBP',
                component: () => import('@/views/sys/finance/InvestorCenter/investorPostBP'),
                meta: {title: "意向BP", requireLogin: true}
            },

            //投资机构 InvestmentInstitutions
            {
                path: '/finance/investmentOrganizationInformation',
                name: 'finance_investmentOrganizationInformation',
                component: () => import('@/views/sys/finance/InvestmentInstitutions/investmentOrganizationInformation'),
                meta: {title: "基本信息", requireLogin: true}
            },
            {
                path: '/finance/demandInvestmentManager',
                name: 'finance_demandInvestmentManager',
                component: () => import('@/views/sys/finance/InvestmentInstitutions/demandInvestmentManager'),
                meta: {title: "基本信息", requireLogin: true}
            },
            {
                path: '/finance/investmentOrganizationGetBP',
                name: 'finance_investmentOrganizationGetBP',
                component: () => import('@/views/sys/finance/InvestmentInstitutions/investmentOrganizationGetBP'),
                meta: {title: "基本信息", requireLogin: true}
            },
            {
                path: '/finance/investmentOrganizationPostBP',
                name: 'finance_investmentOrganizationPostBP',
                component: () => import('@/views/sys/finance/InvestmentInstitutions/investmentOrganizationPostBP'),
                meta: {title: "基本信息", requireLogin: true}
            },

            //投资经理 investmentManager
            {
                path: '/finance/investmentManagerInformation',
                name: 'finance_investmentManagerInformation',
                component: () => import('@/views/sys/finance/investmentManager/investmentManagerInformation'),
                meta: {title: "基本信息", requireLogin: true}
            },
            {
                path: '/finance/investmentManagerGetBP',
                name: 'finance_investmentManagerGetBP',
                component: () => import('@/views/sys/finance/investmentManager/investmentManagerGetBP'),
                meta: {title: "基本信息", requireLogin: true}
            },
            {
                path: '/finance/investmentManagerPostBP',
                name: 'finance_investmentManagerPostBP',
                component: () => import('@/views/sys/finance/investmentManager/investmentManagerPostBP'),
                meta: {title: "基本信息", requireLogin: true}
            },

            //金融机构 financingInstitution
            {
                path: '/finance/financingInstitutionInformation',
                name: 'finance_financingInstitutionInformation',
                component: () => import('@/views/sys/finance/financingInstitution/financingInstitutionInformations'),
                meta: {title: "基本信息", requireLogin: true}
            },
            {
                path: '/finance/financingInstitutionProduct',
                name: 'finance_financingInstitutionProduct',
                component: () => import('@/views/sys/finance/financingInstitution/financingInstitutionProduct'),
                meta: {title: "产品列表", requireLogin: true}
            },
            {
                path: '/finance/financingInstitutionApplication',
                name: 'finance_financingInstitutionApplication',
                component: () => import('@/views/sys/finance/financingInstitution/financingInstitutionApplication'),
                meta: {title: "收到申请录", requireLogin: true}
            },
            {
                path: '/finance/demandFinancialAdvisor',
                name: 'finance_demandFinancialAdvisor',
                component: () => import('@/views/sys/finance/financingInstitution/demandFinancialAdvisor'),
                meta: {title: "金融顾问管理", requireLogin: true}
            },
            {
                path: '/finance/needAdvisor',
                name: 'finance_needAdvisor',
                component: () => import('@/views/sys/finance/needAdvisor'),
                meta: { title: "顾问咨询", requireLogin: true },
            },

            //金融顾问 financialAdvisor
            {
                path: '/finance/financialAdvisorInformation',
                name: 'finance_financialAdvisorInformation',
                component: () => import('@/views/sys/finance/financialAdvisor/financialAdvisorInformation'),
                meta: {title: "基本信息", requireLogin: true}
            },
            {
                path: '/finance/financialAdvisorAdvice',
                name: 'finance_financialAdvisorAdvice',
                component: () => import('@/views/sys/finance/financialAdvisor/financialAdvisorAdvice'),
                meta: {title: "提出咨询", requireLogin: true}
            },
            {
                path: '/finance/financialAdvisorReply',
                name: 'finance_financialAdvisorReply',
                component: () => import('@/views/sys/finance/financialAdvisor/financialAdvisorReply'),
                meta: {title: "咨询回复", requireLogin: true}
            },
            {
                path: '/finance/financialAdvisorEvaluate',
                name: 'finance_financialAdvisorEvaluate',
                component: () => import('@/views/sys/finance/financialAdvisor/financialAdvisorEvaluate'),
                meta: {title: "咨询评价", requireLogin: true}
            },

            // TODO 科技金融结束

            // TODO 科技人才开始
            // 企业用户
            {
                path: '/sys/education/company',
                name: 'education_company',
                component: () => import('@/views/sys/education/company'),
                meta: {title: "企业中心", requireLogin: true}
            },
            {
                path: '/sys/education/recruitment',
                name: 'education_recruitment',
                component: () => import('@/views/sys/education/recruitment'),
                meta: {title: "招聘岗位", requireLogin: true}
            },
            {
                path: '/sys/education/company_invited',
                name: 'education_company_invited',
                component: () => import('@/views/sys/education/companyInvited'),
                meta: {title: "邀请面试", requireLogin: true}
            },
            {
                path: '/sys/education/position_application',
                name: 'education_position_application',
                component: () => import('@/views/sys/education/positionApplication'),
                meta: {title: "职位申请", requireLogin: true}
            },
            {
                path: '/sys/education/personal_recommendation',
                name: 'education_personal_recommendation',
                component: () => import('@/views/sys/education/personalRecommendation'),
                meta: {title: "适合我的", requireLogin: true}
            },
            {
                path: '/sys/education/docking_meeting',
                name: 'education_docking_meeting',
                component: () => import('@/views/sys/education/dockingMeeting'),
                meta: {title: "专场对接会报名", requireLogin: true}
            },
            {
                path: '/sys/education/notification',
                name: 'education_notification',
                component: () => import('@/views/sys/education/notification'),
                meta: {title: "消息通知", requireLogin: true}
            },
            {
                path: '/sys/education/enterprise_talent',
                name: 'education_enterprise_talent',
                component: () => import('@/views/sys/education/enterpriseTalent'),
                meta: {title: "企业人才", requireLogin: true}
            },
            // 个人用户
            {
                path: '/sys/education/personal',
                name: 'education_personal',
                component: () => import('@/views/sys/education/personal'),
                meta: {title: "个人中心", requireLogin: true}
            },
            {
                path: '/sys/education/resume_information',
                name: 'education_resume_information',
                component: () => import('@/views/sys/education/resumeInformation'),
                meta: {title: "简历信息", requireLogin: true}
            },
            {
                path: '/sys/education/employment_intention',
                name: 'education_employment_intention',
                component: () => import('@/views/sys/education/employmentIintention'),
                meta: {title: "求职意向", requireLogin: true}
            },
            {
                path: '/sys/education/resume_delivery',
                name: 'education_resume_delivery',
                component: () => import('@/views/sys/education/resumeDelivery'),
                meta: {title: "简历投递", requireLogin: true}
            },
            {
                path: '/sys/education/interview_invitation',
                name: 'education_interview_invitation',
                component: () => import('@/views/sys/education/interviewInvitation'),
                meta: {title: "面试邀请", requireLogin: true}
            },
            {
                path: '/sys/education/talentSubsidy_apply',
                name: 'education_talentSubsidy_apply',
                component: () => import('@/views/sys/education/talentSubsidyApply'),
                meta: {title: "人才补贴", requireLogin: true}
            },
            {
                path: '/sys/education/job_recommendation',
                name: 'education_job_recommendation',
                component: () => import('@/views/sys/education/jobRecommendation'),
                meta: {title: "岗位推荐", requireLogin: true}
            },
            {
                path: '/sys/education/resume_manage',
                name: 'education_resume_manage',
                component: () => import('@/views/sys/education/resumeManage'),
                meta: {title: "简历管理", requireLogin: true}
            },
            // {
            //     path: '/sys/education/my_appointment',
            //     name: 'education_my_appointment',
            //     component: () => import('@/views/sys/education/myAppointment'),
            //     meta: {title: "我的预约", requireLogin: true}
            // },
                        // {
            //     path: '/sys/education/my_activity',
            //     name: 'education_my_activity',
            //     component: () => import('@/views/sys/education/myActivity'),
            //     meta: {title: "我的活动", requireLogin: true}
            // },

            //TODO 知识产权开始
            {
                path: '/sys/knowledge/collect',
                name: 'knowledge-collect',
                component: () => import('@/views/sys/knowledge/collect'),
                meta: {title: "我的收藏", requireLogin: true}
            },
            {
                path: '/sys/knowledge/visit',
                name: 'knowledge-visit',
                component: () => import('@/views/sys/knowledge/visit'),
                meta: {title: "安全中心", requireLogin: true}
            },
            {
                path: '/sys/knowledge/abutment',
                name: 'knowledge-abutment',
                component: () => import('@/views/sys/knowledge/abutment'),
                meta: {title: "对接需求管理", requireLogin: true}
            },
            {
                path: '/sys/knowledge/need',
                name: 'knowledge-need',
                component: () => import('@/views/sys/knowledge/need'),
                meta: {title: "产权保护需求", requireLogin: true}
            },
            {
                path: '/sys/knowledge/needTrade',
                name: 'knowledge-needTrade',
                component: () => import('@/views/sys/knowledge/needTrade'),
                meta: {title: "产权交易需求", requireLogin: true}
            },
            {
                path: '/sys/knowledge/ownership/brand',
                name: 'knowledge-ownership-brand',
                component: () => import('@/views/sys/knowledge/ownership/brand'),
                meta: {title: "商标", requireLogin: true}
            },
            {
                path: '/sys/knowledge/ownership/copyright',
                name: 'knowledge-ownership-copyright',
                component: () => import('@/views/sys/knowledge/ownership/copyright'),
                meta: {title: "版权", requireLogin: true}
            },
            {
                path: '/sys/knowledge/ownership/patent',
                name: 'knowledge-ownership-patent',
                component: () => import('@/views/sys/knowledge/ownership/patent'),
                meta: {title: "专利", requireLogin: true}
            },
            {
                path: '/sys/knowledge/trade/sell',
                name: 'knowledge-trade-sell',
                component: () => import('@/views/sys/knowledge/trade/sell'),
                meta: {title: "产权出售", requireLogin: true}
            },
            {
                path: '/sys/knowledge/trade/purchase',
                name: 'knowledge-trade-purchase',
                component: () => import('@/views/sys/knowledge/trade/purchase'),
                meta: {title: "产权购买", requireLogin: true}
            },

            //TODO 知识产权结束



            //TODO 科技成果转化开始

            {
                path: '/sys/technology/abutment',
                name: 'technology-abutment',
                component: () => import('@/views/sys/technology/abutment'),
                meta: {title: "对接需求管理", requireLogin: true}
            },
            {
                path: '/sys/technology/itemNeed',
                name: 'technology-itemNeed',
                component: () => import('@/views/sys/technology/itemNeed'),
                meta: {title: "技术需求", requireLogin: true}
            },
            {
                path: '/sys/technology/achievement',
                name: 'technology-achievement',
                component: () => import('@/views/sys/technology/achievement'),
                meta: {title: "成果管理", requireLogin: true}
            },
            {
                path: '/sys/technology/corpProject',
                name: 'technology-corpProject',
                component: () => import('@/views/sys/technology/corpProject'),
                meta: {title: "项目管理", requireLogin: true}
            },
            {
                path: '/sys/technology/projectEvaluation',
                name: 'technology-projectEvaluation',
                component: () => import('@/views/sys/technology/projectEvaluation'),
                meta: {title: "项目评估", requireLogin: true}
            },
            {
                path: '/sys/technology/person',
                name: 'technology-person',
                component: () => import('@/views/sys/technology/person'),
                meta: {title: "个人信息", requireLogin: true}
            },
            {
                path: '/sys/technology/requirementDocking',
                name: 'technology-requirementDocking',
                component: () => import('@/views/sys/technology/requirementDocking'),
                meta: {title: "需求对接", requireLogin: true}
            },
            {
                path: '/sys/technology/visit',
                name: 'technology-visit',
                component: () => import('@/views/sys/technology/visit'),
                meta: {title: "安全管理", requireLogin: true}
            },
            
            //TODO 科技成果转化结束

            // 项目信息化评审
            ...review
        ]
    },



]
